/** Shared Design Language 2.0 Shape / CornerRadius modes. */
export const Shape = {
  Squared: "squared",
  Circular: "circular",
  Rounded: "rounded",
} as const

export type Shape = (typeof Shape)[keyof typeof Shape]

/** Omitted shapes follow the inherited default, responsive unless a container overrides it. */
export const defaultShapeStyle = "rounded-shape-default"

/** Components opt into shape support through these shared token-backed utilities. */
export const shapeStyles = {
  squared: "rounded-shape-squared",
  circular: "rounded-shape-circular",
  rounded: "rounded-shape-rounded",
} satisfies Record<Shape, string>
